import I18n from './I18n'

function hidePopovers(e) {
  $('[data-toggle="popover"]').each(function () {
    //the 'is' for buttons that trigger popups
    //the 'has' for icons within a button that triggers a popup
    if (
      !$(this).is(e.target) &&
      $(this).has(e.target).length === 0 &&
      $('.popover').has(e.target).length === 0
    ) {
      $(this).popover('hide')
    }
  })
}

function cleanPopoverState(e) {
  $(e.target).data('bs.popover').inState = {
    click: false,
    hover: false,
    focus: false,
  }
}
export function registerClickAwayHidePopover(): void {
  // Popover on Vention
  $('body').on('click', hidePopovers)
  $('body').on('hidden.bs.popover', cleanPopoverState)
}

export function unregisterClickAwayHidePopover(): void {
  // Popover on Vention
  $('body').unbind('click', hidePopovers)
  $('body').unbind('hidden.bs.popover', cleanPopoverState)
}

export function scrollToClass(pClassName: string): void {
  $('html, body').animate({ scrollTop: $(`.${pClassName}`).position().top - 100 }, 'fast')
}

const EXCHANGE_POLLING_INTERVAL_MS = 1000
async function exchangeAsync(id: string, exchangeEndpoint: string): Promise<Response> {
  const statusUrl = new URL(`${exchangeEndpoint}/tasks?id=${id}`)
  const output = await new Promise<Response>((resolve, reject) => {
    const checkStatus = async (): Promise<void> => {
      const output = await fetch(statusUrl, { method: 'GET' })
      if (!output.ok) {
        reject(new Error(output.status.toString()))
        return
      }

      if (output.status === 200) {
        resolve(output)
      } else {
        setTimeout(() => {
          void checkStatus()
        }, EXCHANGE_POLLING_INTERVAL_MS)
      }
    }

    void checkStatus()
  })

  return output
}

export function downloadDesignStepFile(assemblyGraphJSON, downloadBtnId, callback) {
  let pDesignNumber
  let pDesignVersion
  let pGraphJson

  function forceDownload(_pStepDownloadLink: { assembly_step_uri: string }) {
    // Force download of .STEP file
    location.replace(_pStepDownloadLink.assembly_step_uri)

    // Set href to new download link
    $(`#${downloadBtnId}`).attr('href', _pStepDownloadLink.assembly_step_uri)
    $(`#${downloadBtnId}`).attr('onclick', null)
  }
  function showErrorMessage(_pErrorMessage) {

    toastr.error(_pErrorMessage)
  }
  function preferredHost() {
    if (location.protocol.match(/http(s?)/)) {
      return `${location.protocol}//${location.hostname}:${location.port}`
    } else {
      // Would be nice for debugging in standalone, but appears not to work well due to CORS enforcements.
      return 'http://localhost:3000'
    }
  }
  function doAjax(pOptions: Parameters<typeof $.ajax>[0]) {
    $.ajax(pOptions)
  }
  function doExport(exchangeEndpoint: string) {
    doAjax({
      url: `${exchangeEndpoint}/designs/export`,
      type: 'POST',
      data: {
        payload: {
          design_number: pDesignNumber,
          design_version: pDesignVersion,
          graph_json: pGraphJson,
        },
      },
      dataType: 'json',
      success: (_pData: { id: string }) => {
        exchangeAsync(_pData.id, exchangeEndpoint).then((response) => response.json()).then((finalData: { assembly_step_uri: string }) => {
          forceDownload(finalData)
          callback()
        }).catch((error) => {
          showErrorMessage(`Sorry, there was an unexpected error: ${error}`)
          callback()
        })
      },
      error: () => {
        showErrorMessage('Sorry, there was an unexpected error.')
        callback()
      },
    })
  }

  if (undefined != assemblyGraphJSON && null != assemblyGraphJSON) {
    const pAssemblyGraph = assemblyGraphJSON
    pDesignNumber = pAssemblyGraph.designId
    pDesignVersion = pAssemblyGraph.graphVersion
    pGraphJson = JSON.stringify(pAssemblyGraph.graph)
    const exporterConfigurationPath = '/api/v3/assembler/exchange/configuration/exporter'
    doAjax({
      url: preferredHost() + exporterConfigurationPath,
      type: 'GET',
      dataType: 'json',
      data: {
        id: pDesignNumber,
        type: 'Design',
      },
      success: function (_pData) {
        if (undefined != _pData) {
          if (_pData.quota_reached) {
            showErrorMessage(I18n.t('frontend.components.common.step_file_download.daily_limit_hit'))
          } else {
            doExport(_pData.endpoint)
          }
        } else {
          console.log('alloc_exporter_endpoint did not return endpoint')
        }
      },
      error: function () {
        console.log('Failed to alloc_exporter_endpoint!')
      },
    })
  } else {
    showErrorMessage('Error: Assembly graph is undefined. Please contact support.')
  }
}
